var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormatUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 96 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 936v-80h560v80H200Zm280-160q-101 0-157-63t-56-167V216h103v336q0 56 28 91t82 35q54 0 82-35t28-91V216h103v330q0 104-56 167t-157 63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatUnderline);
export default __webpack_public_path__ + "static/media/format_underline.1fd00dba68c43965b1a5a9112cb97abf.svg";
export { ForwardRef as ReactComponent };